import flags, { Flags } from 'common/constants/flags';

export const getFlagImageByCode = (flagCode: string) => (
  flags[flagCode.toLowerCase() as Flags] || ''
);

